import { render, staticRenderFns } from "./GoodsTender.vue?vue&type=template&id=8beaddbc&"
import script from "./GoodsTender.vue?vue&type=script&lang=js&"
export * from "./GoodsTender.vue?vue&type=script&lang=js&"
import style0 from "./GoodsTender.vue?vue&type=style&index=0&id=8beaddbc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports